<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-gear" /> Account Settings
      </div>
      <div class="card-block">
        <div class="list-group">
          <router-link
            :to="'/admin/account-settings/set-up-google2fa'"
            class="list-group-item list-group-item-action active"
          >
            Set Up Google2FA
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AccountSettings',
};
</script>



// WEBPACK FOOTER //
// Index.vue?38ca7412